// ArChat Error Messages
// Created: 17-03-2026 12:30:00
// Author: SIVOL® - Aldo Frias - Argentina

const ALREADY_CONTACT_MESSAGE_BY_LANG = {
  es: 'Este usuario ya estaba en ArChat® y fue agregado a tus contactos.',
  en: 'This user was already on ArChat® and has been added to your contacts.',
  pt: 'Este usuário já estava no ArChat® e foi adicionado aos seus contatos.',
  fr: 'Cet utilisateur était déjà sur ArChat® et a été ajouté à vos contacts.',
  de: 'Dieser Nutzer war bereits auf ArChat® und wurde zu deinen Kontakten hinzugefügt.',
  it: 'Questo utente era già su ArChat® ed è stato aggiunto ai tuoi contatti.',
  ru: 'Этот пользователь уже был в ArChat® и был добавлен в ваши контакты.',
  zh: '该用户已在 ArChat® 上，已添加到你的联系人中。',
  ja: 'このユーザーはすでに ArChat® に登録されており、連絡先に追加されました。',
  ko: '이 사용자는 이미 ArChat®에 있었으며 연락처에 추가되었습니다.',
  ar: 'هذا المستخدم كان موجودا بالفعل في ArChat® وتمت إضافته إلى جهات اتصالك.',
  hi: 'यह उपयोगकर्ता पहले से ArChat® पर था और आपके संपर्कों में जोड़ दिया गया है।',
  pl: 'Ten użytkownik był już w ArChat® i został dodany do Twoich kontaktów.',
  el: 'Αυτός ο χρήστης ήταν ήδη στο ArChat® και προστέθηκε στις επαφές σας.',
  tr: 'Bu kullanıcı zaten ArChat® üzerindeydi ve kişilerinize eklendi.',
  sv: 'Den här användaren fanns redan i ArChat® och har lagts till i dina kontakter.',
  he: 'המשתמש הזה כבר היה ב-ArChat® ונוסף לאנשי הקשר שלך.',
  nl: 'Deze gebruiker was al op ArChat® en is toegevoegd aan je contacten.',
};

function normalizeLanguageCode(language) {
  return String(language || 'en').toLowerCase().slice(0, 2);
}

export function resolveApiErrorMessage(code, language) {
  if (code !== 'ALREADY_CONTACT') return null;
  const lang = normalizeLanguageCode(language);
  return {
    code: 'ALREADY_CONTACT',
    type: 'info',
    isPositiveFlow: true,
    message: ALREADY_CONTACT_MESSAGE_BY_LANG[lang] || ALREADY_CONTACT_MESSAGE_BY_LANG.en,
  };
}

export { ALREADY_CONTACT_MESSAGE_BY_LANG };
